'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareItem = ShareItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _displayTypes = require('./displayTypes');

var _displayTypes2 = _interopRequireDefault(_displayTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Share count number is only being shown if greater than this constant.
 * @const {number}
 */

/**
 * A single share button. This is usually not exposed, but is a
 * sub-component of {@link ShareButtons}
 * @module shareItem
 * @version 1.1
 */

var minimumShares = 30;
var iconReplacement = {
  'facebook': 'facebook',
  'twitter': 'twitter',
  'whatsapp': 'whatsapp',
  'share': 'mail'
};

function shareCountFormatter(count) {
  return count >= minimumShares ? count : '';
}

/**
 * A share item is a single sharing item, consisting of a link with an icon.
 * Using display types, this item can be displayed in different ways, either
 * as a list item or as a button.
 *
 * @param {ShareItemProps} props
 */
function ShareItem(_ref) {
  var displayType = _ref.displayType,
      _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === undefined ? false : _ref$inverted,
      type = _ref.type,
      count = _ref.count,
      description = _ref.description,
      shareUrl = _ref.shareUrl,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var itemClass = type + ' ' + (inverted ? 'inverted' : '') + ' ' + className + ' share';
  var innerText = void 0;

  switch (displayType) {
    case _displayTypes2.default.HORIZONTAL_ICONS:
      itemClass = itemClass + ' item';
      innerText = shareCountFormatter(count);
      break;

    case _displayTypes2.default.VERTICAL_BUTTONS:
      itemClass = className + ' ' + (inverted ? 'inverted' : '') + ' ui button share';
      innerText = description;
      break;

    case _displayTypes2.default.HORIZONTAL_BUTTONS:
      itemClass = iconReplacement[type] + ' ' + className + ' ui icon button share';
      innerText = shareCountFormatter(count);
      break;
  }

  return _react2.default.createElement(
    'a',
    { href: shareUrl,
      title: description,
      className: itemClass,
      onClick: onClick,
      target: '_top' },
    _react2.default.createElement('i', { className: iconReplacement[type] + ' icon' }),
    ' ',
    innerText
  );
}

exports.default = ShareItem;


//////////////////
// WEBPACK FOOTER
// ./~/@ta-interaktiv/react-share-buttons/dist/shareItem.js
// module id = 36
// module chunks = 0